import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* updateLaborEntryStatus(action: any): SagaReturnType<any> {
  // The id rides along on every action so the row that was actioned can show its own
  // pending / failed state while other rows stay untouched.
  const { labourManagementId, status } = action?.payload || {};
  try {
    yield put({
      type: laborHoursConstant.UPDATE_LABOR_ENTRY_STATUS_LOADER,
      payload: { labourManagementId },
    });
    const response = yield call(laborHoursService.updateLaborEntryStatus, action.payload);
    if (response?.status === 200) {
      yield put({
        type: laborHoursConstant.UPDATE_LABOR_ENTRY_STATUS_SUCCESS,
        payload: { labourManagementId, status, data: response.data },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({
      type: laborHoursConstant.UPDATE_LABOR_ENTRY_STATUS_FAILURE,
      payload: { labourManagementId, error },
    });
  }
}

function* updateLaborEntryStatusSaga() {
  yield takeEvery(laborHoursConstant.UPDATE_LABOR_ENTRY_STATUS_REQUEST, updateLaborEntryStatus);
}

export default updateLaborEntryStatusSaga;
